import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "l-container-pageheader l-container l-bg-primary" }
const _hoisted_3 = { class: "m-pageHeader" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "m-pageHeader__rimL" }, null, -1)
const _hoisted_5 = { class: "m-pageHeader__container" }
const _hoisted_6 = { class: "m-pageHeader__row" }
const _hoisted_7 = {
  key: 0,
  class: "m-pageHeader__row"
}
const _hoisted_8 = { class: "m-pageHeader__filters" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "m-pageHeader__count" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "m-pageHeader__rimR" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInputComponent = _resolveComponent("SearchInputComponent")!
  const _component_FilterComponent = _resolveComponent("FilterComponent")!
  const _component_icon_component = _resolveComponent("icon-component")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    id: "search-component",
    class: "o-searchComponent",
    "data-qa": _ctx.SearchQASelectors.SEARCH_INPUT_COMPONENT
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(_component_SearchInputComponent, {
                label: _ctx.searchLabel,
                name: 'api-search',
                icon: _ctx.IconName.Search
              }, null, 8, ["label", "icon"])
            ], 32),
            _createVNode(_component_FilterComponent, {
              data: _ctx.data,
              "cities-label": _ctx.citiesLabel
            }, null, 8, ["data", "cities-label"])
          ]),
          (_ctx.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.showActiveFilters)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.appliedFiltersStore.$state, (list, c) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (typeof list !== 'string' && c !== 'offset')
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(list, (f) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  class: "a-btnSmall -primary -filtered",
                                  onClick: ($event: any) => (_ctx.clearFilter(c,f))
                                }, [
                                  _createVNode(_component_icon_component, {
                                    "icon-id": _ctx.IconName.Cross,
                                    class: "a-btnIcon"
                                  }, null, 8, ["icon-id"]),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.getFilterName(c, f)), 1)
                                ], 8, _hoisted_9))
                              }), 256))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    : _createCommentVNode("", true),
                  (_ctx.appliedFiltersStore.$state.dateStart || _ctx.appliedFiltersStore.$state.dateEnd)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "a-btnSmall -primary -filtered",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearDates && _ctx.clearDates(...args)))
                      }, [
                        _createVNode(_component_icon_component, {
                          "icon-id": _ctx.IconName.Cross,
                          class: "a-btnIcon"
                        }, null, 8, ["icon-id"]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDateForDisplay(_ctx.appliedFiltersStore.$state.dateStart as Date)) + " - " + _toDisplayString(_ctx.formatDateForDisplay(_ctx.appliedFiltersStore.$state.dateEnd as Date)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives((_openBlock(), _createElementBlock("span", null, [
                    _createTextVNode("Events")
                  ])), [
                    [_directive_translate, { key: this.Translation.Navigation_section_events }]
                  ]),
                  _createTextVNode(":   " + _toDisplayString(_ctx.numOfEvents), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_11
      ])
    ])
  ], 8, _hoisted_1))
}